export default __webpack_public_path__ + "static/media/act1@2x.62b77754.png";